<template>
  <div class="page">
    <div class="mainPage" :style="{background: isHome() ? 'linear-gradient(180deg, #ebf1f5 0%, #f7f8fa 100%)' : 'none'}">
      <!-- :class="{ 'small-screen': !isLargeScreen }" -->
      <!-- 导航栏 -->
      <Menu ref="menuRef" id="menuId" :isHome="isHome()"></Menu>

      <!-- 中间主体部分 -->
      <div
        class="mainBox"
        id="mainBox"
        ref="myRef"
        :style="{
          padding:0,
          paddingTop: navHeight + 'px',
          minHeight: mainHeight + 'px',
          maxWidth: isFullWidth ? 'none' : '1200px',
        }"
      >
        <router-view :isFullWidth="isFullWidth" />
      </div>

      <!-- 页脚   -->
      <footerComp id="footerId" ref="footerRef"></footerComp>
    </div>
  </div>

  <!-- 置顶悬浮按钮 -->
  <GoTop ref="goTopRef" />


  <!-- 右侧悬浮按钮 -->
  <FixedBtn :isFixed="true"></FixedBtn>
</template>

<script lang="ts" setup>
import Menu from "@/components/Menu.vue";
import footerComp from "@/components/footer.vue";
import FixedBtn from "@/components/fixedBtn.vue";
import {
  ref,
  onMounted,
  onUnmounted,
  getCurrentInstance,
  computed,
  nextTick,
} from "vue";
import GoTop from "@/components/goTop.vue";
import {useRoute} from 'vue-router'

const route = useRoute();
console.log('route-------',route)
const { proxy } = getCurrentInstance() as any;

const isLargeScreen = ref(window.innerWidth >= 960);
const goTopRef = ref(0);

const updateScreenSize = () => {
  isLargeScreen.value = window.innerWidth >= 960;
};
const navHeight = ref(0);

// 根据当前路由判断是否需要全屏宽度
const isFullWidth = computed(() => {
  // 通过路由meta配置决定是否启用全屏
  return route.meta.fullWidth === true;
});
onUnmounted(() => {
  window.removeEventListener("resize", updateScreenSize);
  window.removeEventListener("scroll", handleScroll);
});

const footerRef = ref<HTMLElement>();
const menuRef = ref<HTMLElement>();
const myRef = ref<HTMLElement>();

// 中间主体部分高度
const mainHeight = ref<number>(0);

const isMin = ref(false);

// 屏幕宽度
const screenWidth = ref(0);

// 设置中间高度，保证页脚在页面底部
const setMainHeight = () => {
  // 获取导航栏高度
  navHeight.value = document.getElementById("menuId")?.clientHeight;

  // 获取底部页脚高度
  let footerHeight = document.getElementById("footerId")?.clientHeight;

  console.log(navHeight, footerHeight);

  // 获取浏览器高度document.documentElement.clientHeight
  let mHeight = document.documentElement.clientHeight - (footerHeight || 0);
  mainHeight.value = mHeight;
  console.log('mainHeight', mainHeight.value);
};

onMounted(() => {
  // 设置中间高度，保证页脚在页面底部
  setMainHeight();

  window.addEventListener("resize", updateScreenSize);

  //监听页面滚动事件
  window.addEventListener("scroll", handleScroll);
});

//处理滚动事件
const handleScroll = (event) => {
  //展示回到顶部按钮
  if (window.scrollY > 1000) {
    goTopRef.value?.showTop();
  } else {
    goTopRef.value?.hideTop();
  }
};

/**
 * 判断是否是首页
 */
const isHome = ()=>{
  return route.name === 'home'
}
</script>

<style lang="scss" scoped>
.page {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  background:#F7F8FA;
}

.mainPage{
  min-width: 960px;
  overflow: hidden;
  background-size: 100% 750px;
}

/* ≥960px：固定宽度 + 居中 */
.large-screen {
  width: 960px;
  margin: 0 auto;
}

/* <960px：基于960px等比缩放 */
.small-screen {
  transform: scale(calc(var(--scale-ratio)));
  transform-origin: top left;
  width: 960px;
  /* 原始设计尺寸 */
}
</style>
